import request from 'utils/request';
import buildQueryParams from '../utils/buildQueryParams';

export const getRoles = params => request.get(`/roles`, { params: buildQueryParams(params) });
export const getPermissions = () => request.get(`/roles/permissions`);
export const createRole = role => request.post('/roles', role);
export const updateRole = role => request.put(`/roles/${role.id}`, role);
export const deleteRole = id => request.delete(`/roles/${id}`);
